// extracted by mini-css-extract-plugin
module.exports = {"component":"_1210vZiVAi2IcnGO3t8w5h","emphasis":"_1i5vyW-iylsyA_0SgNJ6QZ","svg":"_3eZgOkx6vgC0qgzv2rKMTc","noMargin":"_2QV8VIssOMNIg5w7eEBEJK"};